const SmallCircle = ({
  size = "15px",
  borderRadius = "50%",
  color = "#1bbb6b",
}) => {
  return (
    <>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: borderRadius,
          backgroundColor: color,
        }}
      ></div>
    </>
  );
};

export default SmallCircle;
